import angular from 'angular';
import { isNil } from 'lodash';

module.exports = angular.module('common.directives.comma-number', [])
.directive('type', function typeCommaNumber(numberFilter, formattedCursorPosition) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function link(scope, element, attrs, ngModel) {
      if (attrs.type !== 'commaNumber' || !ngModel) return;

      const precision = parseInt(attrs.precision || 0);

      // String with commas -> Number
      ngModel.$parsers.push(function(oldValue) {
        if (!oldValue) return null;

        const numbers = oldValue.toString().trim().replace(/[^\d\.]/g, '');
        const hasDecimal = numbers[numbers.length - 1] === '.';

        let newValue = numberFilter(numbers, precision);
        if (precision) {
          newValue = newValue.replace(/\.?0+$/, '');
          if (hasDecimal)
            newValue += '.';
        }

        let oldCursorPosition = element[0].selectionStart;
        let newCursorPosition = formattedCursorPosition(oldCursorPosition, oldValue, newValue);
        element.val(newValue);
        ngModel.$setViewValue(newValue);
        ngModel.$commitViewValue();
        element[0].setSelectionRange(newCursorPosition, newCursorPosition);

        // Ensure that the model is a well typed Number
        return numbers === '.' ? 0 : Number(numbers);
      });

      // Number -> String with commas
      ngModel.$formatters.push(function(value) {
        if (isNil(value)) return;

        value = numberFilter(value, precision);
        if (precision)
          value = value.replace(/\.?0+$/, '');
        return value;
      });
    },
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/comma-number.js
 **/